import type { Mount } from "../../api/types";

interface MountsListProps {
  mounts: Mount[];
}

/**
 * The folders that exist inside the workspace, and which ones survive it.
 *
 * Args:
 *     mounts: Mounts as served with the workspace.
 *
 * Returns:
 *     A list of folders with a one-line explanation each.
 */
export function MountsList({ mounts }: MountsListProps): JSX.Element {
  if (mounts.length === 0) {
    return <p className="mounts__empty">No folder has been reported yet.</p>;
  }

  return (
    <ul className="mounts">
      {mounts.map((mount) => (
        <li className="mounts__item" key={mount.path}>
          <span className="mono mounts__path">{mount.path}</span>
          <span className="mounts__description">{mount.description}</span>
          <span
            className={`badge${mount.persistent ? "" : " badge--warning"}`}
          >
            {mount.persistent ? "kept" : "wiped when it stops"}
          </span>
        </li>
      ))}
    </ul>
  );
}
